import { render, staticRenderFns } from "./BalanceOutputNoticeWithoutCard.vue?vue&type=template&id=365bb28e"
import script from "./BalanceOutputNoticeWithoutCard.vue?vue&type=script&lang=js"
export * from "./BalanceOutputNoticeWithoutCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceOutputNoticeWithoutCard.vue?vue&type=style&index=0&id=365bb28e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports